import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "flex justify-center items-center mt-7 mb-2",
    "aria-label": "Pagination"
};
const _hoisted_2 = { class: "flex items-center mx-2 lg:mx-10" };
const _hoisted_3 = { class: "ml-2" };
const _hoisted_4 = { class: "font-semibold" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RouterLink = _resolveComponent("RouterLink");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("nav", _hoisted_1, [
            _createCommentVNode(" Previous Button "),
            _createVNode(_component_RouterLink, {
                to: { query: { ...$setup.route.query, startIndex: $setup.firstPageIndex } },
                class: _normalizeClass([(!$setup.isFirstPage) ? '' : 'opacity-30 pointer-events-none', 'relative inline-flex -mr-[1px] items-center rounded-l-md px-1.75 py-1.75 text-gray-900 ring-1 ring-inset ring-gray-300 bg-white hover:bg-gray-50 focus:z-20 focus:outline-offset-0'])
            }, {
                default: _withCtx(() => [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Last", -1 /* CACHED */)),
                    _createVNode($setup["ChevronDoubleLeftIcon"], {
                        class: "size-2",
                        "aria-hidden": "true"
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "class"]),
            _createVNode(_component_RouterLink, {
                to: { query: { ...$setup.route.query, startIndex: $setup.currentIndex - $props.itemsPerPage } },
                class: _normalizeClass([(!$setup.isFirstPage) ? '' : 'opacity-30 pointer-events-none', 'relative inline-flex items-center rounded-r-md px-1.75 py-1.75 text-gray-900 ring-1 ring-inset ring-gray-300 bg-white hover:bg-gray-50 focus:z-20 focus:outline-offset-0'])
            }, {
                default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sr-only" }, "Previous", -1 /* CACHED */)),
                    _createVNode($setup["ChevronLeftIcon"], {
                        class: "size-2",
                        "aria-hidden": "true"
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "class"]),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, _toDisplayString($setup.$t('Page')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "pageNumber",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.currentPage) = $event)),
                    onChange: $setup.onChangePageNumber,
                    class: "ml-2 inline-block !w-5.5 rounded-md bg-white text-center py-1.25 text-base font-semibold text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-mertl-blue"
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelText, $setup.currentPage]
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString($setup.$t('of')) + " ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_4, _toDisplayString($setup.lastPage), 1 /* TEXT */)
                ])
            ]),
            _createCommentVNode(" Next Button "),
            _createVNode(_component_RouterLink, {
                to: { query: { ...$setup.route.query, startIndex: $setup.currentIndex + $props.itemsPerPage } },
                class: _normalizeClass([(!$setup.isLastPage) ? '' : 'opacity-30 pointer-events-none', 'relative inline-flex items-center rounded-l-md px-1.75 py-1.75 text-gray-900 ring-1 ring-inset ring-gray-300 bg-white hover:bg-gray-50 focus:z-20 focus:outline-offset-0'])
            }, {
                default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sr-only" }, "Next", -1 /* CACHED */)),
                    _createVNode($setup["ChevronRightIcon"], {
                        class: "size-2",
                        "aria-hidden": "true"
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "class"]),
            _createVNode(_component_RouterLink, {
                to: { query: { ...$setup.route.query, startIndex: $setup.lastPageIndex } },
                class: _normalizeClass([(!$setup.isLastPage) ? '' : 'opacity-30 pointer-events-none', 'relative inline-flex -ml-[1px] items-center rounded-r-md px-1.75 py-1.75 text-gray-900 ring-1 ring-inset ring-gray-300 bg-white hover:bg-gray-50 focus:z-20 focus:outline-offset-0'])
            }, {
                default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "sr-only" }, "Last", -1 /* CACHED */)),
                    _createVNode($setup["ChevronDoubleRightIcon"], {
                        class: "size-2",
                        "aria-hidden": "true"
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "class"])
        ])
    ]));
}
